/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeDatePicker,
  BaSeGrid,
  BaSeGridItem,
  BaSeParagraph,
} from '@base/react';
import React from 'react';

function DateRange({
  title,
  handleChange,
  filters,
  fixedFilters,
  handleFixedFilter,
  insideFilter,
  setFilter,
  convertDate,
}) {
  const handleChangeoUTSIDEfilter = React.useCallback(
    (key, value) => {
      setFilter((prevFilter) => {
        return {
          ...prevFilter,
          [key]: convertDate(value),
        };
      });
    },
    [setFilter, convertDate],
  );
  return (
    <BaSeGrid gap={6}>
      <BaSeGridItem size={insideFilter ? 12 : 8}>
        <BaSeParagraph color="#939393">{title}</BaSeParagraph>
      </BaSeGridItem>

      <BaSeGridItem size={insideFilter ? 5 : 6}>
        <BaSeDatePicker
          size="small"
          onStartDateChange={(date) => {
            handleChange('periodStart', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('periodStart', date);
            }
          }}
          startDate={filters.periodStart}
          onSelect={(date) => {
            handleChange('periodStart', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('periodStart', date);
            }
          }}
          placeholder="Data de início"
        />
      </BaSeGridItem>
      <BaSeGridItem size={insideFilter ? 5 : 6}>
        <BaSeDatePicker
          size="small"
          onStartDateChange={(date) => {
            handleChange('periodEnd', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('periodEnd', date);
            }
          }}
          startDate={filters.periodEnd}
          placeholder="Data de término"
          onSelect={(date) => {
            handleChange('periodEnd', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('periodEnd', date);
            }
          }}
        />
      </BaSeGridItem>

      {insideFilter && (
        <BaSeGridItem size={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeButton
              value={fixedFilters.dateRange ? 'Desafixar' : 'Fixar'}
              type="tertiary"
              color={fixedFilters.dateRange ? '#ffa4a4' : '#005EB8'}
              onClick={() => {
                handleFixedFilter('dateRange');
              }}
            />
          </div>
        </BaSeGridItem>
      )}
    </BaSeGrid>
  );
}

export default DateRange;
